import React from "react";
import { MapContainer, TileLayer, Marker, Polyline, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = (color, label) =>
  L.divIcon({
    className: "",
    html: `<div style="background:${color};color:#05070a;font:700 10px 'JetBrains Mono',monospace;padding:4px 7px;border-radius:999px;box-shadow:0 0 14px ${color};white-space:nowrap">${label}</div>`,
    iconSize: [60, 22],
    iconAnchor: [30, 11],
  });

const PICKUP = pin("#34d399", "PICKUP");
const DROP = pin("#00f0ff", "DROP");
const BOUNDS_OPTS = { padding: [40, 40] };
const LINE_OPTS = { color: "#00f0ff", weight: 3, dashArray: "6 8" };

export default function RiderMap({ order }) {
  if (order.shop_lat == null || order.drop_lat == null) {
    return <div className="mt-3 rounded-xl border border-cyan-500/15 bg-white/5 p-3 text-xs text-slate-400" data-testid={`rider-map-unavailable-${order.order_id}`}>Map unavailable for this order.</div>;
  }
  const pickup = [order.shop_lat, order.shop_lng];
  const drop = [order.drop_lat, order.drop_lng];
  return (
    <div className="mt-3 h-52 rounded-xl overflow-hidden border border-cyan-500/20 relative z-0" data-testid={`rider-map-${order.order_id}`}>
      <MapContainer bounds={[pickup, drop]} boundsOptions={BOUNDS_OPTS} scrollWheelZoom={false} className="h-full w-full rider-map">
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={pickup} icon={PICKUP}><Popup>{order.shop_name}</Popup></Marker>
        <Marker position={drop} icon={DROP}><Popup>{order.customer_name}</Popup></Marker>
        <Polyline positions={[pickup, drop]} pathOptions={LINE_OPTS} />
      </MapContainer>
    </div>
  );
}
